<!-- eslint-disable @angular-eslint/template/mouse-events-have-key-events -->
<span
    class="badge parent-badge d-flex align-items-center gap-1 pe-1"
    [class.text-bg-outline-secondary]="!invalid()"
    [class.text-bg-outline-danger]="invalid()"
    [ngClass]="classes">
    <span class="custom-height"><ng-content></ng-content></span>
    <button
        type="button"
        class="btn btn-sm btn-ghost p-1 d-flex align-items-center custom-height"
        [disabled]="disabled"
        (click)="clear.emit()">
        <fa-icon [icon]="closeIcon" size="sm" class="no-margin"></fa-icon>
    </button>
</span>
